// extracted by mini-css-extract-plugin
export default {"BackButton":"back-button_BackButton__1RKle"};